export default { sha: '85bc02ef53889b334421ad713dd0732c74a0399e', buildNumber: 'undefined' }
